import ApiService from "@/services/ApiService";

export default {
  getData() {
    return ApiService.axios.get("/data");
  }
};
